export default __webpack_public_path__ + "static/media/small_QOSMO-HEADER-PARTICULAR-OHNE-BAR_1.45308294.mp4";